export const GET_ITINERARY_CHANGE_ROUTES = 'GET_ITINERARY_CHANGE_ROUTES';
export const CLEAR_ITINERARY_CHANGE_ROUTES = 'CLEAR_ITINERARY_CHANGE_ROUTES';
export const FLAG_GETTING_ITINERARY_CHANGE_ROUTES =
  'FLAG_GETTING_ITINERARY_CHANGE_ROUTES';
export const FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY =
  'FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY';
export const GET_ITINERARY_CHANGE_ROUTE = 'GET_ITINERARY_CHANGE_ROUTE';
export const CLEAR_ITINERARY_CHANGE_ROUTE = 'CLEAR_ITINERARY_CHANGE_ROUTE';
